import { Loading } from 'task-eva-ui/components/loading'
import { useGlobalStore } from '@/store/global/global-store'
import { ErrorPageWrapper } from '@/components/error-boundary/ErrorBoundary'
import { STORAGE } from 'project-config/constants'

export function AuthGuard({ children }: { children: any }) {
  const { userInfo, shareKey, updateShareKey } = useGlobalStore()
  const networkError = sessionStorage.getItem(STORAGE.USER_NETWORK_ERROR)
  if (networkError) {
    window.sessionStorage.removeItem(STORAGE.USER_NETWORK_ERROR)
    return <ErrorPageWrapper />
  }
  if (!shareKey) {
    const url = new URL(window.location.href)
    const shareKey = url.searchParams.get('shareKey')
    if (shareKey) {
      updateShareKey(shareKey)
    }
  }
  return <>{userInfo?.userId ? children : <Loading />}</>
}
